var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":"img/logo.png","width":"200","alt":"PureteQ"}})]),_c('img',{attrs:{"id":"graphic","src":"img/pq_element-06.png","alt":"PureteQ"}}),_c('h1',[_vm._v(" PureteQ Pure-SPOT is currently unavailable ")]),_c('h3',{staticStyle:{"margin-top":"1rem"}},[_vm._v(" Please check back later ")])])
}]

export { render, staticRenderFns }